import { Button } from '@progress/kendo-react-buttons';
import React from 'react';
import { CheckmarkOutline, CloseOutline, EditOutline, TrashOutline } from '../../icons/icons';
import { UnitFormatter } from '../../formatters';
import LatLngInput from '../common/LatLngInput';

interface DrawingObjectEditPointProps {
    lngLat: number[];
    index: number;
    onDelete: (index: number) => void;
    onChange: (index: number, newPosition: number[]) => void;
    deleteDisabled: boolean;
    disabled: boolean;
}

const DrawingObjectEditPoint = (props: DrawingObjectEditPointProps) => {
    const [edit, setEdit] = React.useState(false);
    const [lat, setLat] = React.useState(0);
    const [lng, setLng] = React.useState(0);

    const updateLat = React.useCallback((e: number | null) => setLat(e ?? 0), []);
    const updateLng = React.useCallback((e: number | null) => setLng(e ?? 0), []);

    React.useEffect(() => {
        setLng(props.lngLat[0]);
        setLat(props.lngLat[1]);
    }, [props.lngLat]);

    const handleSave = () => {
        setEdit(false);
        props.onChange(props.index, [lng, lat]);
    };

    const handleCancel = () => {
        setEdit(false);
    };

    const handleDelete = () => {
        props.onDelete(props.index);
    };

    return (
        <>
            {edit && (
                <>
                    <td className="ps-2">
                        <LatLngInput disabled={props.disabled} value={lat} onChange={updateLat} type={'lat'} />
                    </td>
                    <td>
                        <LatLngInput disabled={props.disabled} value={lng} onChange={updateLng} type={'lng'} />
                    </td>
                </>
            )}

            {!edit && (
                <>
                    <td className="ps-2">{UnitFormatter.formatLatValue(props.lngLat[1])}</td>
                    <td>{UnitFormatter.formatLngValue(props.lngLat[0])}</td>
                </>
            )}

            {edit && (
                <td className="text-end">
                    <Button
                        svgIcon={CheckmarkOutline}
                        fillMode={'outline'}
                        className="button-small"
                        onClick={handleSave}
                        disabled={props.disabled}></Button>
                    <Button
                        svgIcon={CloseOutline}
                        fillMode={'outline'}
                        className="button-small ms-2"
                        onClick={handleCancel}
                        disabled={props.disabled}></Button>
                </td>
            )}

            {!edit && (
                <td className="text-end">
                    <Button
                        svgIcon={EditOutline}
                        fillMode={'outline'}
                        className="button-small"
                        onClick={() => setEdit(true)}
                        disabled={props.disabled}></Button>
                    <Button
                        svgIcon={TrashOutline}
                        fillMode={'outline'}
                        className="button-small ms-2"
                        onClick={handleDelete}
                        disabled={props.deleteDisabled || props.disabled}></Button>
                </td>
            )}
        </>
    );
};

export default DrawingObjectEditPoint;
